
<!--  surveyor details modal -->
<div class="modal fade" id="surveyorDetails" tabindex="-1" role="dialog" aria-labelledby="surveyorDetails" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document" style="width:400px; height:280px;">
    <div class="modal-content" style="height: 280px;">
      <div class="modal-header">
        <div class="row">
          <div class="col-12">
            Surveyor details
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 details content-start">
            <span class="text-1">Name: {{surveyorName}}</span>
          </div>
          <div class="col-12 details content-start mt-8">
            <span class="text-1">Phone no.: {{surveyorPhone}}</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-auto ml-auto">
            <button type="button" class="btn-1 no-border-btn" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>